export default "__VITE_ASSET__eadb8a2b__"